import { useEffect } from 'react'
import { toast } from 'ui/sonner'

import { Route } from '~/routes/subscription'

export const useErrorFromSearchParams = () => {
  const { error } = Route.useSearch()

  useEffect(() => {
    if (error) toast.error(error)
  }, [error])
}
